import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(
      private router: Router,
      private translate: TranslateService) { 
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    let settings = localStorage.getItem('webSecretariatSettings');
    if (settings != null) {
      let language = JSON.parse(settings).language;
      if (language) {
        this.translate.use(language);
      }
    } else {
      let settings = { language: 'en' };
      localStorage.setItem( 'webSecretariatSettings', JSON.stringify(settings) );
    }

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}
